import { NgModule } from '@angular/core';
import { AnchorScrollComponent } from './anchor-scroll.component';

@NgModule({
  imports: [AnchorScrollComponent],
  exports: [AnchorScrollComponent],
})
export class AnchorScrollModule {}
